import { render, staticRenderFns } from "./office.vue?vue&type=template&id=d5cd7e3c&scoped=true"
import script from "./office.vue?vue&type=script&lang=js"
export * from "./office.vue?vue&type=script&lang=js"
import style0 from "./office.vue?vue&type=style&index=0&id=d5cd7e3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5cd7e3c",
  null
  
)

export default component.exports